import { render, staticRenderFns } from "./tipMsg.vue?vue&type=template&id=60fc8785&scoped=true"
import script from "./tipMsg.vue?vue&type=script&lang=js"
export * from "./tipMsg.vue?vue&type=script&lang=js"
import style0 from "./tipMsg.vue?vue&type=style&index=0&id=60fc8785&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc8785",
  null
  
)

export default component.exports